/* comparison-table.js — tab toggle + tooltip touch support for sections/comparison-table.liquid.
   Uses document-level delegation so it survives customizer section reloads without re-init. */
(function () {
  'use strict';

  if (window.__jiyuComparisonTableInit) return;
  window.__jiyuComparisonTableInit = true;

  /* The scroll container clips vertically (see section-comparison-table-v2.css), so a
     bubble on a bottom row would be cut off. Flip it above the icon when it would fall
     past the clipped edge and there is room above. Runs on hover, focus and tap. */
  function positionBubble(tip) {
    var bubble = tip.querySelector('.ct-tooltip__bubble');
    var scroller = tip.closest('.comparison-table__scroll');
    if (!bubble || !scroller) return;
    tip.classList.remove('ct-tooltip--flip');
    var bounds = scroller.getBoundingClientRect();
    var rect = bubble.getBoundingClientRect();
    var roomAbove = tip.getBoundingClientRect().top - bounds.top;
    if (rect.bottom > bounds.bottom && rect.height + 8 <= roomAbove) {
      tip.classList.add('ct-tooltip--flip');
    }
  }

  function closeTooltips(except) {
    document.querySelectorAll('.ct-tooltip.is-open').forEach(function (tip) {
      if (tip === except) return;
      tip.classList.remove('is-open');
      var btn = tip.querySelector('.ct-tooltip__btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function selectTab(tab) {
    var root = tab.closest('.comparison-table');
    if (!root) return;
    var key = tab.getAttribute('data-ct-tab');
    root.querySelectorAll('[data-ct-tab]').forEach(function (t) {
      var selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.setAttribute('tabindex', selected ? '0' : '-1');
    });
    root.querySelectorAll('[data-ct-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-ct-panel') !== key;
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-ct-tab]');
    if (tab) {
      selectTab(tab);
      return;
    }
    var tipBtn = e.target.closest('.ct-tooltip__btn');
    if (tipBtn) {
      var tip = tipBtn.closest('.ct-tooltip');
      positionBubble(tip);
      var open = tip.classList.toggle('is-open');
      tipBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      closeTooltips(tip);
      return;
    }
    closeTooltips(null);
  });

  ['mouseover', 'focusin'].forEach(function (evt) {
    document.addEventListener(
      evt,
      function (e) {
        if (!e.target.closest) return;
        var tip = e.target.closest('.ct-tooltip');
        if (tip) positionBubble(tip);
      },
      { capture: true, passive: true }
    );
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openTip = document.querySelector('.ct-tooltip.is-open');
      if (openTip) {
        closeTooltips(null);
        var btn = openTip.querySelector('.ct-tooltip__btn');
        if (btn) btn.focus();
      }
      return;
    }
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (!e.target.closest) return;
    var tab = e.target.closest('[data-ct-tab]');
    if (!tab) return;
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-ct-tab]'));
    var idx = tabs.indexOf(tab);
    var next = e.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
    e.preventDefault();
    tabs[next].focus();
    selectTab(tabs[next]);
  });
})();
